import Banner from "@/components/pages/about/banner";
import { m } from "framer-motion";
import { fadeIn } from "@/utils/motion/fade-in";
// import DataCard from "@/components/pages/about/data-card";
// import History from "@/components/pages/about/history";
// import JoinUs from "@/components/pages/about/join-us";
// import IconRow from "@/components/pages/about/icon-row";
// import RelatedPosts from "@/components/pages/blog/related-posts";
import { getUrqlClient } from "@/lib/urql-client";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { sanitize } from "@/framework/utils/sanitize";
import { QUERY_ALL_JOURNEY } from "@/framework/queries/journey";
import Seo from "@/utils/seo";
import { QUERY_ALL_BLOGS_SELECTIVE } from "@/framework/queries/blogs";
import { ABOUT_DYNAMIC_IMAGE_QUERY } from "@/framework/queries/aboutDynamicImage";
import { HEADER_AND_TEXT_QUERY } from "@/framework/queries/header_and_text";
import {ABOUT_SECTION_1} from "@/framework/queries/home-section-1";
import dynamic from "next/dynamic";

const IconRow = dynamic(() => import('@/components/pages/about/icon-row'), { ssr: false });
const DataCard = dynamic(() => import('@/components/pages/about/data-card'), { ssr: false });
const History = dynamic(() => import('@/components/pages/about/history'), { ssr: false });
const JoinUs = dynamic(() => import('@/components/pages/about/join-us'), { ssr: false });
const RelatedPosts = dynamic(() => import('@/components/pages/blog/related-posts'), { ssr: false });
export default function About({ press, journey, blogs,aboutDynamicImage,headertxt,aboutSection1 }) {
  const seo = {
    slug: "about",
    metaTitle: "About Chalk Studio – Interior Design Experts Gurgaon",
    metaDescription:
      "Discover Chalk Studio’s design philosophy that unites storytelling, strategy, and client-first creative thinking",
  };

  return (
    <>
      <Seo seo={seo} />
      <m.div
        initial="from"
        whileInView={"to"}
        viewport={{ once: true }}
        variants={fadeIn()}
      >
        <Banner
          tag="Gurugram"
          title="Discover Chalk Studio’s design approach that blends storytelling, research, and client-focused creativity."
          description="28°41’ N, 77°08’E"
          video="/videos/CG-Tower.mp4"
        />
        <DataCard datas={{ headertxt, aboutSection1 }} />
        <History journey={journey} />
        <IconRow aboutDynamicImage={aboutDynamicImage} />
       {/* <IconRow />*/}

        <RelatedPosts
          title="Chalk Edit"
          showSubscribe={true}
          data={blogs}
          showNavAbove={true}
          showButton={false}
          buttonText="view more"
        />
        <JoinUs />
      </m.div>
    </>
  );
}
export async function getStaticProps({ params }) {
  const client = await getUrqlClient();
  let press = null;
  let journey = [];
  let blogs = null;
  let aboutDynamicImage = null;
  let headertxt = null;
  let aboutSection1 = null;
  try {
      const aboutDynamicImageResponse = await client.query(
          ABOUT_DYNAMIC_IMAGE_QUERY, {}, {
          requestPolicy: "network-only",
      });



    const pressResponse = await client.query(
      QUERY_ENDPOINTS.QUERY_ALL_PRESS,
      {
        start: 0,
        limit: 50,
        sortBy: ["id:asc"],
        filter: {},
      },
      { requestPolicy: "network-only" }
    );
    const journeyResponse = await client.query(
      QUERY_ALL_JOURNEY,
      {
        start: 0,
        limit: 50,
        sortBy: ["id:asc"],
        filter: {},
      },
      { requestPolicy: "network-only" }
    );
    const blogResponse = await client.query(
      QUERY_ALL_BLOGS_SELECTIVE,
      {
        start: 0,
        limit: 10,
        sortBy: ["id:desc"],
        filter: {},
      },
      {
        requestPolicy: "network-only",
      }
    );

      aboutDynamicImage = aboutDynamicImageResponse.data?.aboutDynamicImage?.data?.attributes || null;

    if (
      journeyResponse.data &&
      journeyResponse.data.journeys &&
      Array.isArray(journeyResponse.data.journeys.data) // Ensure this is an array
    ) {
      journey = journeyResponse.data.journeys.data.map((row) => sanitize(row));
    } else {
      console.warn(
        "Unexpected structure for journey data",
        journeyResponse.data
      );
    }
    press = pressResponse.data?.presses?.data.map((row) => sanitize(row)) || [];
    blogs = blogResponse.data?.blogs?.data.map((row) => sanitize(row)) || [];

      const headerTextResponse = await client.query(
          HEADER_AND_TEXT_QUERY,
          {
              start: 0,
              limit: 1,
              sort: ["order:asc"],
              filters: {
                  for: { eq: "About" },
                  order: { eq: 1 }
              },
          },
          {
              requestPolicy: "cache-and-network",
          }
      );

      //headertxt=headerTextResponse?.data?.headerAndText?.data?.attributes || [];
      headertxt = headerTextResponse?.data?.headerAndTexts?.data?.[0]?.attributes || {};//Single Records


      const aboutSectionResponse = await client.query(
          ABOUT_SECTION_1,
          {
              start: 0,
              limit: 50,
              sortBy: ["id:asc"],
              filter: {},
          },
          { requestPolicy: "network-only" }
      );
      aboutSection1 = aboutSectionResponse.data?.aboutSection1S?.data || [];

  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      journey: journey ?? {},
      press: press ?? {},
      blogs: blogs ?? {},
      aboutDynamicImage: aboutDynamicImage ?? {},
      headertxt: headertxt ?? {},
      aboutSection1: aboutSection1 ?? {},
    },
    revalidate: 604800, // In seconds
  };
}
